<template>
  <div id="loading-bg-callback">
    <div class="loading-logo-callback">
      <img :src="logoImage" alt="Logo" />
    </div>
    <div class="loading-callback">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script>
import moduleAppLogo from "../store/settings/application-logo/moduleAppLogo.js";

export default {
  data() {
    return {
      logoImage: "",
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.$store.dispatch("updateUserInfo", {
        displayName: data.profile.name,
        email: data.profile.email,
        photoURL: data.profile.picture,
        providerId: data.profile.sub.substr(0, data.profile.sub.indexOf("|")),
        uid: data.profile.sub,
      });
      this.$router.push(data.state.target || "/");
    },
  },
  created() {
    // this.$auth.handleAuthentication()
    // if (this.$auth.isAuthenticated()) this.$router.push('/').catch(() => {})

    const store = this.$store;
    if (!(store && store.state && store.state["appLogo"])) {
      store.registerModule("appLogo", moduleAppLogo);
    }
    var fetchedImageFilePath = this.$store.dispatch(
      "appLogo/fetchAppLogo",
      this
    );
  },
};
</script>

<style lang="scss">
@import "../assets/css/loader.css";
#loading-bg-callback {
  width: 100%;
  height: 100%;
  background: #fff;
  display: block;
  position: absolute;
}

.loading-logo-callback {
  position: absolute;
  left: calc(48% - 45px);
  top: 45%;
}

.loading-callback {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid transparent;
}

.loading-callback .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid red;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading-callback .effect-1 {
  animation: rotate 1s ease infinite;
}

.loading-callback .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}

.loading-callback .effect-3 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid red;
  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading-callback .effects {
  transition: all 0.3s ease;
}
</style>
